import path from '../path.js';

const _map = new Map(
	[
		'sound/correct.mp3',
		'sound/card_flip.mp3',
		'sound/bounce.mp3',
		'sound/finished.mp3',
		'sound/plunger.mp3',
		'sound/suction.mp3',
		'sound/ratchet.mp3',
		'sound/suction_puzzle.mp3'
	].map((src) => {
		const audio = new Audio();
		audio.preload = 'auto';
		audio.src = `${path()}${src}`;
		audio.loop = false;
		audio.load();

		return [src.split('/').reverse()[0].split('.')[0], audio];
	})
);

const _play = (uid, config = {}) => {
	try{
		_muted = !skin.player.getVariableValue('sound');
	} catch(e){

	}

	if(_muted) return;

	let { volume } = config;

	if (volume === undefined) volume = 1;

	let audio = _map.get(uid);
	if (!audio) return;

	audio.currentTime = 0;
	audio.volume = volume;
	audio.play();
};

let _muted = false;

const _ext = {
	play: _play,
	get muted() {
		try{
			_muted = !skin.player.getVariableValue('sound');
		} catch(e){

		}
		return _muted;
	},
	set muted(v) {
		_muted = v;
	}
};

export default _ext;
